import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { Modal, Button, Row, Form, Col, Alert } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../formControls';
import { CustomerAccountService } from '../../services';

const clinicianInitValues = {
    firstName: '',
    lastName: '',
    clinicalManager: false,
    tenantId: 0,
    state: 100
}

const clinicianValidation = Yup.object().shape({
    firstName: Yup.string().required('First name is required.')
        .min(2, 'First name must be longer than one character.')
        .max(200, 'First name must be shorter than 200 characters.'),
    lastName: Yup.string().required('Last name is required.')
        .min(2, 'Last name must be longer than one character.')
        .max(200, 'Last name must be shorter than 200 characters.'),
});

const CreateClinicianModal = (props) => {
    const [clinician, setClinician] = useImmer(clinicianInitValues);
    const [error, setErrors] = useImmer([]);

    useEffect(() => {
        setClinician(draft => {
            Object.assign(draft, props.model);
        });        
    }, [props.model]);

    const saveClinician = async (values) => {
        const service = new CustomerAccountService();

        var results = await service.saveClinician(values);
        if (results.result) {
            // call in to add clinician to list of clinicians in parent model
            props.updateClinician(results.model);
            // close the modal
            props.closeModal();
        }
        else {
            setErrors(draft => {
                draft.push('Error saving clinician.');
            });
        }
    }

    const submitForm = () => {
        if (_.isEmpty(formik.errors)) {
            setErrors([])
            formik.submitForm();
        }
    }

    const formik = useFormik({
        initialValues: clinician,
        validationSchema: clinicianValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            await saveClinician(values);
            setSubmitting(false);
        }
    });

    return (
        <>
            <Modal.Header>{props.model.id > 0 ? "Update" : "Create"} clinician</Modal.Header>
            <Modal.Body>
                {/* 
                <Alert variant="danger" show={ error || formik.errors } transition>
                    <Alert.Header>Errors!</Alert.Header>
                    {
                        //error && (error + '<br/>')
                    }
                        {
                            Object.keys(formik.errors).map(errorKey => {
                                return (formik.errors[errorKey] + '<br/>');
                            })
                        }
                </Alert>
                */}
                
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12" controlId="firstName">
                        <FormControls.Textbox
                            label="First name"
                            name="firstName"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="12" md="12" controlId="lastName">
                        <FormControls.Textbox
                            label="Last name"
                            name="lastName"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="12" md="12" controlId="clinicalManager">
                        <FormControls.ButtonGrouping
                            label="Type"
                            name="clinicalManager"
                            size="sm"
                            variant="secondary"
                            formHandler={formik}
                            options={[{ value: false, name: "Clinician" }, { value: true, name: "Clinical Manager" }]} />
                    </Form.Group>
                    <ConditionalRender visible={props.model.id > 0}>
                        <Form.Group as={Col} lg="12" md="12" controlId="state">
                            <FormControls.ButtonGrouping
                                label="State"
                                name="state"
                                size="sm"
                                variant="secondary"
                                formHandler={formik}
                                options={[{ value: 100, name: "Active" }, { value: -100, name: "Deleted" }]} />
                        </Form.Group>
                    </ConditionalRender>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={() => props.closeModal()}>Cancel</Button>
                <Button variant="primary" onClick={() => submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
}

export default CreateClinicianModal;